import { MediaView } from 'common';

export const useObjectLabels = (media: MediaView) => ({
  productIdsExact: media.productIdsExact ?? [],
  productIdsSimilar: media.productIdsSimilar ?? [],
});
